import React from 'react';
import {
  useMediaQuery,
  useTheme,
  makeStyles,
  createStyles,
  Theme,
} from '@material-ui/core';
import { SettingsSidebarBackToggle } from '../Sidebar/SettingsSidebarBackToggle';
import BaseTypography from '../Text/BaseTypography';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    settingsHeaderTitleWrapper: {
      display: 'flex',
      alignItems: 'center',
    },
  }),
);
export const SettingsPageHeaderTitle: React.FC = () => {
  const classes = useStyles();
  const theme = useTheme();
  const isSmScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return isSmScreen ? (
    <div className={classes.settingsHeaderTitleWrapper}>
      <SettingsSidebarBackToggle />

      <BaseTypography fontType="15Medium">Settings</BaseTypography>
    </div>
  ) : null;
};
